// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddPhoneNumberData, AddPhoneNumberErrors, AddPhoneNumberResponses, AdminFlagBulletinMultipleData, AdminFlagBulletinMultipleErrors, AdminFlagBulletinMultipleResponses, AdminUnflagBulletinMultipleData, AdminUnflagBulletinMultipleErrors, AdminUnflagBulletinMultipleResponses, AllowAlertAccessData, AllowAlertAccessErrors, AllowAlertAccessResponses, BackfillSearchTsvectorData, BackfillSearchTsvectorResponses, BatchEmailBulletinsData, BatchEmailBulletinsErrors, BatchEmailBulletinsIndividualData, BatchEmailBulletinsIndividualErrors, BatchEmailBulletinsIndividualResponses, BatchEmailBulletinsResponses, CreateBulletinData, CreateBulletinErrors, CreateBulletinResolutionData, CreateBulletinResolutionErrors, CreateBulletinResolutionResponses, CreateBulletinResponses, CreateBulletinTypeBypassData, CreateBulletinTypeBypassErrors, CreateBulletinTypeBypassResponses, CreateBulletinTypeData, CreateBulletinTypeErrors, CreateBulletinTypeResponses, CreateCrimeTypeData, CreateCrimeTypeErrors, CreateCrimeTypeResponses, CreateMailingListData, CreateMailingListErrors, CreateMailingListResponses, CreateOrgConfigData, CreateOrgConfigErrors, CreateOrgConfigResponses, CreateTagRequestData, CreateTagRequestErrors, CreateTagRequestResponses, DeleteBulletinAttachmentData, DeleteBulletinAttachmentErrors, DeleteBulletinAttachmentResponses, DeleteBulletinIdData, DeleteBulletinIdErrors, DeleteBulletinIdResponses, DeleteBulletinPdfData, DeleteBulletinPdfErrors, DeleteBulletinPdfResponses, DeleteBulletinResolutionData, DeleteBulletinResolutionErrors, DeleteBulletinResolutionResponses, DeleteBulletinTypeBypassData, DeleteBulletinTypeBypassErrors, DeleteBulletinTypeBypassResponses, DeleteBulletinTypeData, DeleteBulletinTypeErrors, DeleteBulletinTypeResponses, DeleteCrimeTypeData, DeleteCrimeTypeErrors, DeleteCrimeTypeResponses, DeleteMailingListData, DeleteMailingListErrors, DeleteMailingListResponses, DeleteOrgConfigData, DeleteOrgConfigErrors, DeleteOrgConfigResponses, DeleteOrgGroupPermissionsData, DeleteOrgGroupPermissionsErrors, DeleteOrgGroupPermissionsResponses, DeleteResolutionAttachmentData, DeleteResolutionAttachmentErrors, DeleteResolutionAttachmentResponses, DeleteTagData, DeleteTagErrors, DeleteTagResponses, DownloadBulletinPdfData, DownloadBulletinPdfErrors, DownloadBulletinPdfResponses, DownloadResolutionAttachmentData, DownloadResolutionAttachmentErrors, DownloadResolutionAttachmentResponses, DownloadResolutionThumbnailData, DownloadResolutionThumbnailErrors, DownloadResolutionThumbnailResponses, EmailBulletinData, EmailBulletinErrors, EmailBulletinResponses, ExtractImagesFromPdfData, ExtractImagesFromPdfErrors, ExtractImagesFromPdfResponses, ExtractTextFromPdfData, ExtractTextFromPdfErrors, ExtractTextFromPdfResponses, GetAuthSsoStartData, GetAuthSsoStartErrors, GetAuthSsoStartResponses, GetAuthUserMetabaseViewData, GetAuthUserMetabaseViewErrors, GetAuthUserMetabaseViewResponses, GetBulletinAccessGroupData, GetBulletinAccessGroupErrors, GetBulletinAccessGroupResponses, GetBulletinAccessManagementData, GetBulletinAccessManagementErrors, GetBulletinAccessManagementResponses, GetBulletinAccessMeData, GetBulletinAccessMeErrors, GetBulletinAccessMeResponses, GetBulletinAccessMyGroupsData, GetBulletinAccessMyGroupsErrors, GetBulletinAccessMyGroupsResponses, GetBulletinAccessOtherGroupsData, GetBulletinAccessOtherGroupsErrors, GetBulletinAccessOtherGroupsResponses, GetBulletinAttachmentData, GetBulletinAttachmentErrors, GetBulletinAttachmentPublicData, GetBulletinAttachmentPublicErrors, GetBulletinAttachmentPublicResponses, GetBulletinAttachmentResponses, GetBulletinByIdData, GetBulletinByIdErrors, GetBulletinByIdResponses, GetBulletinByIdViewData, GetBulletinByIdViewErrors, GetBulletinByIdViewResponses, GetBulletinData, GetBulletinDraftData, GetBulletinDraftErrors, GetBulletinDraftResponses, GetBulletinErrors, GetBulletinIdGroupsData, GetBulletinIdGroupsErrors, GetBulletinIdGroupsResponses, GetBulletinImagesData, GetBulletinImagesErrors, GetBulletinImagesResponses, GetBulletinMyAccessData, GetBulletinMyAccessErrors, GetBulletinMyAccessResponses, GetBulletinNeighborsData, GetBulletinNeighborsErrors, GetBulletinNeighborsResponses, GetBulletinPinsData, GetBulletinPinsErrors, GetBulletinPinsResponses, GetBulletinResponses, GetBulletinScopeChangeRequestData, GetBulletinScopeChangeRequestErrors, GetBulletinScopeChangeRequestResponses, GetBulletinShareData, GetBulletinShareErrors, GetBulletinShareResponses, GetBulletinSharesByBulletinIdData, GetBulletinSharesByBulletinIdErrors, GetBulletinSharesByBulletinIdResponses, GetBulletinThumbnailData, GetBulletinThumbnailErrors, GetBulletinThumbnailPublicData, GetBulletinThumbnailPublicErrors, GetBulletinThumbnailPublicResponses, GetBulletinThumbnailResponses, GetBulletinTypeBypassesData, GetBulletinTypeBypassesErrors, GetBulletinTypeBypassesResponses, GetBulletinTypesData, GetBulletinTypesPublicData, GetBulletinTypesPublicResponses, GetBulletinTypesResponses, GetCrimeTypesAdminData, GetCrimeTypesAdminResponses, GetCrimeTypesData, GetCrimeTypesResponses, GetGroupBulletinSharesData, GetGroupBulletinSharesErrors, GetGroupBulletinSharesResponses, GetGroupByIdData, GetGroupByIdErrors, GetGroupByIdResponses, GetGroupMemberData, GetGroupMemberErrors, GetGroupMemberPermissionsData, GetGroupMemberPermissionsErrors, GetGroupMemberPermissionsResponses, GetGroupMemberResponses, GetGroupMembersData, GetGroupMembersErrors, GetGroupMembersResponses, GetGroupsData, GetGroupsErrors, GetGroupsResponses, GetGroupStatsData, GetGroupStatsErrors, GetGroupStatsResponses, GetGroupUsersData, GetGroupUsersErrors, GetGroupUsersResponses, GetMailingListByIdData, GetMailingListByIdErrors, GetMailingListByIdResponses, GetMailingListsData, GetMailingListsResponses, GetNonMembersData, GetNonMembersErrors, GetNonMembersResponses, GetOrgConfigData, GetOrgConfigErrors, GetOrgConfigResponses, GetOrgGroupPermissionsData, GetOrgGroupPermissionsErrors, GetOrgGroupPermissionsResponses, GetOrgOrgIdData, GetOrgOrgIdErrors, GetOrgOrgIdResponses, GetOrgOrgIdUserData, GetOrgOrgIdUserErrors, GetOrgOrgIdUserResponses, GetOrgPyData, GetOrgPyResponses, GetOrgSsoDetailsData, GetOrgSsoDetailsErrors, GetOrgSsoDetailsResponses, GetPoliceServicesData, GetPoliceServicesErrors, GetPoliceServicesGroupPublicData, GetPoliceServicesGroupPublicErrors, GetPoliceServicesGroupPublicResponses, GetPoliceServicesResponses, GetPublicBulletinDetailData, GetPublicBulletinDetailErrors, GetPublicBulletinDetailResponses, GetPublicGroupBulletinsData, GetPublicGroupBulletinsErrors, GetPublicGroupBulletinsResponses, GetResolutionReasonsData, GetResolutionReasonsErrors, GetResolutionReasonsResponses, GetUserData, GetUserErrors, GetUserMeGroupsData, GetUserMeGroupsResponses, GetUserPublicGroupsData, GetUserPublicGroupsResponses, GetUserResponses, GetUsersMeData, GetUsersMeResponses, GetUserUserIdData, GetUserUserIdErrors, GetUserUserIdPermissionsData, GetUserUserIdPermissionsErrors, GetUserUserIdPermissionsResponses, GetUserUserIdResponses, GetVehicleMakesPublicData, GetVehicleMakesPublicResponses, GetVehicleModelsPublicData, GetVehicleModelsPublicErrors, GetVehicleModelsPublicResponses, GetViewBulletinAttachmentFilenameData, GetViewBulletinAttachmentFilenameErrors, GetViewBulletinAttachmentFilenameResponses, GetViewBulletinPdfData, GetViewBulletinPdfErrors, GetViewBulletinPdfResponses, GetViewBulletinThumbnailFilenameData, GetViewBulletinThumbnailFilenameErrors, GetViewBulletinThumbnailFilenameResponses, InsertItemToMailingListData, InsertItemToMailingListErrors, InsertItemToMailingListResponses, ListBulletinScopeChangeRequestData, ListBulletinScopeChangeRequestResponses, ListBulletinShareData, ListBulletinShareErrors, ListBulletinShareResponses, MigrateData, MigrateResponses, PatchBulletinIdAttachmentFilenameData, PatchBulletinIdAttachmentFilenameErrors, PatchBulletinIdAttachmentFilenameResponses, PatchBulletinIdData, PatchBulletinIdErrors, PatchBulletinIdResponses, PatchBulletinResolutionData, PatchBulletinResolutionErrors, PatchBulletinResolutionResponses, PatchBulletinShareData, PatchBulletinShareErrors, PatchBulletinShareResponses, PatchBulletinTypeData, PatchBulletinTypeErrors, PatchBulletinTypeResponses, PatchCrimeTypeData, PatchCrimeTypeErrors, PatchCrimeTypeResponses, PatchGroupData, PatchGroupErrors, PatchGroupResponses, PatchTagRequestData, PatchTagRequestErrors, PatchTagRequestResponses, PatchUserData, PatchUserErrors, PatchUserResponses, PostAuthEmailResetFlowResetData, PostAuthEmailResetFlowResetErrors, PostAuthEmailResetFlowResetResponses, PostAuthLoginData, PostAuthLoginErrors, PostAuthLoginResponses, PostAuthLogoutData, PostAuthLogoutResponses, PostAuthPasswordResetData, PostAuthPasswordResetErrors, PostAuthPasswordResetResponses, PostAuthResetData, PostAuthResetErrors, PostAuthResetResponses, PostAuthStrengthCheckData, PostAuthStrengthCheckErrors, PostAuthStrengthCheckResponses, PostBulkUpdateGroupsData, PostBulkUpdateGroupsErrors, PostBulkUpdateGroupsResponses, PostBulletinAddGroupData, PostBulletinAddGroupErrors, PostBulletinAddGroupResponses, PostBulletinAddGroupsData, PostBulletinAddGroupsErrors, PostBulletinAddGroupsResponses, PostBulletinCreateBulletinUrlSignedParamsData, PostBulletinCreateBulletinUrlSignedParamsErrors, PostBulletinCreateBulletinUrlSignedParamsResponses, PostBulletinGroupExpireDateData, PostBulletinGroupExpireDateErrors, PostBulletinGroupExpireDateResponses, PostBulletinRemoveGroupData, PostBulletinRemoveGroupErrors, PostBulletinRemoveGroupResponses, PostBulletinScopeChangeRequestApproveData, PostBulletinScopeChangeRequestApproveErrors, PostBulletinScopeChangeRequestApproveResponses, PostBulletinScopeChangeRequestData, PostBulletinScopeChangeRequestErrors, PostBulletinScopeChangeRequestRejectData, PostBulletinScopeChangeRequestRejectErrors, PostBulletinScopeChangeRequestRejectResponses, PostBulletinScopeChangeRequestResponses, PostBulletinShareAdmitData, PostBulletinShareAdmitErrors, PostBulletinShareAdmitResponses, PostBulletinShareData, PostBulletinShareErrors, PostBulletinShareRejectData, PostBulletinShareRejectErrors, PostBulletinShareRejectResponses, PostBulletinShareResponses, PostBulletinShareRevokeData, PostBulletinShareRevokeErrors, PostBulletinShareRevokeResponses, PostGroupIdAddMemberData, PostGroupIdAddMemberErrors, PostGroupIdAddMemberResponses, PostGroupIdRemoveMemberData, PostGroupIdRemoveMemberErrors, PostGroupIdRemoveMemberResponses, PostIntelRequestSubmissionData, PostIntelRequestSubmissionErrors, PostIntelRequestSubmissionResponses, PostOrganizationMapData, PostOrganizationMapErrors, PostOrganizationMapResponses, PostOrgGroupPermissionsData, PostOrgGroupPermissionsErrors, PostOrgGroupPermissionsResponses, PostUserUserIdAddPermissionData, PostUserUserIdAddPermissionErrors, PostUserUserIdAddPermissionResponses, PostUserUserIdDemoteFromOrgAdminData, PostUserUserIdDemoteFromOrgAdminErrors, PostUserUserIdDemoteFromOrgAdminResponses, PostUserUserIdDisableData, PostUserUserIdDisableErrors, PostUserUserIdDisableResponses, PostUserUserIdPromoteToOrgAdminData, PostUserUserIdPromoteToOrgAdminErrors, PostUserUserIdPromoteToOrgAdminResponses, PostUserUserIdRemovePermissionData, PostUserUserIdRemovePermissionErrors, PostUserUserIdRemovePermissionResponses, PostUserUserIdResendInviteData, PostUserUserIdResendInviteErrors, PostUserUserIdResendInviteResponses, ProcessInviteData, ProcessInviteErrors, ProcessInviteResponses, ProcessTokenData, ProcessTokenErrors, ProcessTokenResponses, PutGroupData, PutGroupErrors, PutGroupResponses, PutOrgGroupPermissionsData, PutOrgGroupPermissionsErrors, PutOrgGroupPermissionsResponses, PutOrgOrgIdUserData, PutOrgOrgIdUserErrors, PutOrgOrgIdUserResponses, PutOrgPyData, PutOrgPyErrors, PutOrgPyResponses, PutUserData, PutUserErrors, PutUserResponses, RemoveItemFromMailingListData, RemoveItemFromMailingListErrors, RemoveItemFromMailingListResponses, ResendCodeData, ResendCodeErrors, ResendCodeResponses, SearchBulletinGroupsData, SearchBulletinGroupsErrors, SearchBulletinGroupsResponses, SearchBulletinsData, SearchBulletinsErrors, SearchBulletinsResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, UpdateApplicationAccessData, UpdateApplicationAccessErrors, UpdateApplicationAccessResponses, UpdateBulletinMembershipPermissionData, UpdateBulletinMembershipPermissionErrors, UpdateBulletinMembershipPermissionResponses, UpdateGroupMemberPermissionsData, UpdateGroupMemberPermissionsErrors, UpdateGroupMemberPermissionsResponses, UpdateOrgConfigData, UpdateOrgConfigErrors, UpdateOrgConfigResponses, UploadBulletinAttachmentData, UploadBulletinAttachmentErrors, UploadBulletinAttachmentResponses, UploadBulletinPdfData, UploadBulletinPdfErrors, UploadBulletinPdfResponses, UploadResolutionAttachmentData, UploadResolutionAttachmentErrors, UploadResolutionAttachmentResponses, VerifyOtpData, VerifyOtpErrors, VerifyOtpResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Resend Code
 */
export const resendCode = <ThrowOnError extends boolean = false>(options: Options<ResendCodeData, ThrowOnError>): RequestResult<ResendCodeResponses, ResendCodeErrors, ThrowOnError> => (options.client ?? client).post<ResendCodeResponses, ResendCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/resend_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Phone Number
 */
export const addPhoneNumber = <ThrowOnError extends boolean = false>(options: Options<AddPhoneNumberData, ThrowOnError>): RequestResult<AddPhoneNumberResponses, AddPhoneNumberErrors, ThrowOnError> => (options.client ?? client).post<AddPhoneNumberResponses, AddPhoneNumberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/add_phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Otp
 */
export const verifyOtp = <ThrowOnError extends boolean = false>(options: Options<VerifyOtpData, ThrowOnError>): RequestResult<VerifyOtpResponses, VerifyOtpErrors, ThrowOnError> => (options.client ?? client).post<VerifyOtpResponses, VerifyOtpErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/verify_otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Auth Login
 *
 * Log in
 */
export const postAuthLogin = <ThrowOnError extends boolean = false>(options: Options<PostAuthLoginData, ThrowOnError>): RequestResult<PostAuthLoginResponses, PostAuthLoginErrors, ThrowOnError> => (options.client ?? client).post<PostAuthLoginResponses, PostAuthLoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Auth Logout
 *
 * Log out
 */
export const postAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLogoutData, ThrowOnError>): RequestResult<PostAuthLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthLogoutResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/logout',
    ...options
});

/**
 * Post Auth Strength Check
 *
 * Check password strength
 */
export const postAuthStrengthCheck = <ThrowOnError extends boolean = false>(options: Options<PostAuthStrengthCheckData, ThrowOnError>): RequestResult<PostAuthStrengthCheckResponses, PostAuthStrengthCheckErrors, ThrowOnError> => (options.client ?? client).post<PostAuthStrengthCheckResponses, PostAuthStrengthCheckErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/strength_check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Auth Reset
 *
 * Begin the password reset flow
 */
export const postAuthReset = <ThrowOnError extends boolean = false>(options: Options<PostAuthResetData, ThrowOnError>): RequestResult<PostAuthResetResponses, PostAuthResetErrors, ThrowOnError> => (options.client ?? client).post<PostAuthResetResponses, PostAuthResetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Process Token
 *
 * Magic login
 */
export const processToken = <ThrowOnError extends boolean = false>(options?: Options<ProcessTokenData, ThrowOnError>): RequestResult<ProcessTokenResponses, ProcessTokenErrors, ThrowOnError> => (options?.client ?? client).get<ProcessTokenResponses, ProcessTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/process_token',
    ...options
});

/**
 * Post Auth Email Reset Flow Reset
 *
 * Reset your own password using the token generated by /auth/reset
 */
export const postAuthEmailResetFlowReset = <ThrowOnError extends boolean = false>(options: Options<PostAuthEmailResetFlowResetData, ThrowOnError>): RequestResult<PostAuthEmailResetFlowResetResponses, PostAuthEmailResetFlowResetErrors, ThrowOnError> => (options.client ?? client).post<PostAuthEmailResetFlowResetResponses, PostAuthEmailResetFlowResetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/email_reset_flow_reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Process Invite
 */
export const processInvite = <ThrowOnError extends boolean = false>(options?: Options<ProcessInviteData, ThrowOnError>): RequestResult<ProcessInviteResponses, ProcessInviteErrors, ThrowOnError> => (options?.client ?? client).get<ProcessInviteResponses, ProcessInviteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/process_invite',
    ...options
});

/**
 * Set Password
 *
 * Reset your own password using the token generated by /auth/reset
 */
export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>): RequestResult<SetPasswordResponses, SetPasswordErrors, ThrowOnError> => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/set_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Auth Password Reset
 *
 * Update your own password
 */
export const postAuthPasswordReset = <ThrowOnError extends boolean = false>(options: Options<PostAuthPasswordResetData, ThrowOnError>): RequestResult<PostAuthPasswordResetResponses, PostAuthPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<PostAuthPasswordResetResponses, PostAuthPasswordResetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/password_reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Sso Details
 */
export const getOrgSsoDetails = <ThrowOnError extends boolean = false>(options: Options<GetOrgSsoDetailsData, ThrowOnError>): RequestResult<GetOrgSsoDetailsResponses, GetOrgSsoDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetOrgSsoDetailsResponses, GetOrgSsoDetailsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/org/{org_slug}',
    ...options
});

/**
 * Get Auth Sso Start
 */
export const getAuthSsoStart = <ThrowOnError extends boolean = false>(options: Options<GetAuthSsoStartData, ThrowOnError>): RequestResult<GetAuthSsoStartResponses, GetAuthSsoStartErrors, ThrowOnError> => (options.client ?? client).get<GetAuthSsoStartResponses, GetAuthSsoStartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/auth/sso_start/{connection_id}',
    ...options
});

/**
 * Get Users Me
 *
 * Get active User
 */
export const getUsersMe = <ThrowOnError extends boolean = false>(options?: Options<GetUsersMeData, ThrowOnError>): RequestResult<GetUsersMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUsersMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/me',
    ...options
});

/**
 * Get Auth User Metabase View
 *
 * Get Metabase view access token
 */
export const getAuthUserMetabaseView = <ThrowOnError extends boolean = false>(options?: Options<GetAuthUserMetabaseViewData, ThrowOnError>): RequestResult<GetAuthUserMetabaseViewResponses, GetAuthUserMetabaseViewErrors, ThrowOnError> => (options?.client ?? client).get<GetAuthUserMetabaseViewResponses, GetAuthUserMetabaseViewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/metabase_view',
    ...options
});

/**
 * Get Org Org Id
 */
export const getOrgOrgId = <ThrowOnError extends boolean = false>(options: Options<GetOrgOrgIdData, ThrowOnError>): RequestResult<GetOrgOrgIdResponses, GetOrgOrgIdErrors, ThrowOnError> => (options.client ?? client).get<GetOrgOrgIdResponses, GetOrgOrgIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}',
    ...options
});

/**
 * Get Org Py
 */
export const getOrgPy = <ThrowOnError extends boolean = false>(options?: Options<GetOrgPyData, ThrowOnError>): RequestResult<GetOrgPyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOrgPyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/org',
    ...options
});

/**
 * Put Org Py
 */
export const putOrgPy = <ThrowOnError extends boolean = false>(options: Options<PutOrgPyData, ThrowOnError>): RequestResult<PutOrgPyResponses, PutOrgPyErrors, ThrowOnError> => (options.client ?? client).put<PutOrgPyResponses, PutOrgPyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Org Id User
 */
export const getOrgOrgIdUser = <ThrowOnError extends boolean = false>(options: Options<GetOrgOrgIdUserData, ThrowOnError>): RequestResult<GetOrgOrgIdUserResponses, GetOrgOrgIdUserErrors, ThrowOnError> => (options.client ?? client).get<GetOrgOrgIdUserResponses, GetOrgOrgIdUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}/user',
    ...options
});

/**
 * Put Org Org Id User
 */
export const putOrgOrgIdUser = <ThrowOnError extends boolean = false>(options: Options<PutOrgOrgIdUserData, ThrowOnError>): RequestResult<PutOrgOrgIdUserResponses, PutOrgOrgIdUserErrors, ThrowOnError> => (options.client ?? client).put<PutOrgOrgIdUserResponses, PutOrgOrgIdUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Group Permissions
 *
 * List all group permission mappings for an organization
 */
export const getOrgGroupPermissions = <ThrowOnError extends boolean = false>(options: Options<GetOrgGroupPermissionsData, ThrowOnError>): RequestResult<GetOrgGroupPermissionsResponses, GetOrgGroupPermissionsErrors, ThrowOnError> => (options.client ?? client).get<GetOrgGroupPermissionsResponses, GetOrgGroupPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}/group-permissions',
    ...options
});

/**
 * Post Org Group Permissions
 *
 * Create a new group permission mapping for an organization
 */
export const postOrgGroupPermissions = <ThrowOnError extends boolean = false>(options: Options<PostOrgGroupPermissionsData, ThrowOnError>): RequestResult<PostOrgGroupPermissionsResponses, PostOrgGroupPermissionsErrors, ThrowOnError> => (options.client ?? client).post<PostOrgGroupPermissionsResponses, PostOrgGroupPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}/group-permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Org Group Permissions
 *
 * Delete a group permission mapping
 */
export const deleteOrgGroupPermissions = <ThrowOnError extends boolean = false>(options: Options<DeleteOrgGroupPermissionsData, ThrowOnError>): RequestResult<DeleteOrgGroupPermissionsResponses, DeleteOrgGroupPermissionsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrgGroupPermissionsResponses, DeleteOrgGroupPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}/group-permissions/{sso_group_id}',
    ...options
});

/**
 * Put Org Group Permissions
 *
 * Update an existing group permission mapping
 */
export const putOrgGroupPermissions = <ThrowOnError extends boolean = false>(options: Options<PutOrgGroupPermissionsData, ThrowOnError>): RequestResult<PutOrgGroupPermissionsResponses, PutOrgGroupPermissionsErrors, ThrowOnError> => (options.client ?? client).put<PutOrgGroupPermissionsResponses, PutOrgGroupPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/org/{org_id}/group-permissions/{sso_group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User User Id
 */
export const getUserUserId = <ThrowOnError extends boolean = false>(options: Options<GetUserUserIdData, ThrowOnError>): RequestResult<GetUserUserIdResponses, GetUserUserIdErrors, ThrowOnError> => (options.client ?? client).get<GetUserUserIdResponses, GetUserUserIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}',
    ...options
});

/**
 * Patch User
 */
export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>): RequestResult<PatchUserResponses, PatchUserErrors, ThrowOnError> => (options.client ?? client).patch<PatchUserResponses, PatchUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> => (options?.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user',
    ...options
});

/**
 * Put User
 */
export const putUser = <ThrowOnError extends boolean = false>(options: Options<PutUserData, ThrowOnError>): RequestResult<PutUserResponses, PutUserErrors, ThrowOnError> => (options.client ?? client).put<PutUserResponses, PutUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User User Id Permissions
 */
export const getUserUserIdPermissions = <ThrowOnError extends boolean = false>(options: Options<GetUserUserIdPermissionsData, ThrowOnError>): RequestResult<GetUserUserIdPermissionsResponses, GetUserUserIdPermissionsErrors, ThrowOnError> => (options.client ?? client).get<GetUserUserIdPermissionsResponses, GetUserUserIdPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/permissions',
    ...options
});

/**
 * Post User User Id Add Permission
 */
export const postUserUserIdAddPermission = <ThrowOnError extends boolean = false>(options: Options<PostUserUserIdAddPermissionData, ThrowOnError>): RequestResult<PostUserUserIdAddPermissionResponses, PostUserUserIdAddPermissionErrors, ThrowOnError> => (options.client ?? client).post<PostUserUserIdAddPermissionResponses, PostUserUserIdAddPermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/add_permission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post User User Id Remove Permission
 */
export const postUserUserIdRemovePermission = <ThrowOnError extends boolean = false>(options: Options<PostUserUserIdRemovePermissionData, ThrowOnError>): RequestResult<PostUserUserIdRemovePermissionResponses, PostUserUserIdRemovePermissionErrors, ThrowOnError> => (options.client ?? client).post<PostUserUserIdRemovePermissionResponses, PostUserUserIdRemovePermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/remove_permission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post User User Id Disable
 */
export const postUserUserIdDisable = <ThrowOnError extends boolean = false>(options: Options<PostUserUserIdDisableData, ThrowOnError>): RequestResult<PostUserUserIdDisableResponses, PostUserUserIdDisableErrors, ThrowOnError> => (options.client ?? client).post<PostUserUserIdDisableResponses, PostUserUserIdDisableErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/disable',
    ...options
});

/**
 * Update Application Access
 */
export const updateApplicationAccess = <ThrowOnError extends boolean = false>(options: Options<UpdateApplicationAccessData, ThrowOnError>): RequestResult<UpdateApplicationAccessResponses, UpdateApplicationAccessErrors, ThrowOnError> => (options.client ?? client).post<UpdateApplicationAccessResponses, UpdateApplicationAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post User User Id Promote To Org Admin
 */
export const postUserUserIdPromoteToOrgAdmin = <ThrowOnError extends boolean = false>(options: Options<PostUserUserIdPromoteToOrgAdminData, ThrowOnError>): RequestResult<PostUserUserIdPromoteToOrgAdminResponses, PostUserUserIdPromoteToOrgAdminErrors, ThrowOnError> => (options.client ?? client).post<PostUserUserIdPromoteToOrgAdminResponses, PostUserUserIdPromoteToOrgAdminErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/promote_to_org_admin',
    ...options
});

/**
 * Post User User Id Demote From Org Admin
 */
export const postUserUserIdDemoteFromOrgAdmin = <ThrowOnError extends boolean = false>(options: Options<PostUserUserIdDemoteFromOrgAdminData, ThrowOnError>): RequestResult<PostUserUserIdDemoteFromOrgAdminResponses, PostUserUserIdDemoteFromOrgAdminErrors, ThrowOnError> => (options.client ?? client).post<PostUserUserIdDemoteFromOrgAdminResponses, PostUserUserIdDemoteFromOrgAdminErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/demote_from_org_admin',
    ...options
});

/**
 * Post User User Id Resend Invite
 */
export const postUserUserIdResendInvite = <ThrowOnError extends boolean = false>(options: Options<PostUserUserIdResendInviteData, ThrowOnError>): RequestResult<PostUserUserIdResendInviteResponses, PostUserUserIdResendInviteErrors, ThrowOnError> => (options.client ?? client).post<PostUserUserIdResendInviteResponses, PostUserUserIdResendInviteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/resend_invite',
    ...options
});

/**
 * Post Organization Map
 */
export const postOrganizationMap = <ThrowOnError extends boolean = false>(options: Options<PostOrganizationMapData, ThrowOnError>): RequestResult<PostOrganizationMapResponses, PostOrganizationMapErrors, ThrowOnError> => (options.client ?? client).post<PostOrganizationMapResponses, PostOrganizationMapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/organization_map',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin By Id View
 *
 * Get a Bulletin by ID and Key
 */
export const getBulletinByIdView = <ThrowOnError extends boolean = false>(options?: Options<GetBulletinByIdViewData, ThrowOnError>): RequestResult<GetBulletinByIdViewResponses, GetBulletinByIdViewErrors, ThrowOnError> => (options?.client ?? client).get<GetBulletinByIdViewResponses, GetBulletinByIdViewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/view/bulletin',
    ...options
});

/**
 * Get View Bulletin Pdf
 *
 * Download
 */
export const getViewBulletinPdf = <ThrowOnError extends boolean = false>(options?: Options<GetViewBulletinPdfData, ThrowOnError>): RequestResult<GetViewBulletinPdfResponses, GetViewBulletinPdfErrors, ThrowOnError> => (options?.client ?? client).get<GetViewBulletinPdfResponses, GetViewBulletinPdfErrors, ThrowOnError>({ url: '/py/view/bulletin/pdf', ...options });

/**
 * Get View Bulletin Attachment Filename
 *
 * Download
 */
export const getViewBulletinAttachmentFilename = <ThrowOnError extends boolean = false>(options: Options<GetViewBulletinAttachmentFilenameData, ThrowOnError>): RequestResult<GetViewBulletinAttachmentFilenameResponses, GetViewBulletinAttachmentFilenameErrors, ThrowOnError> => (options.client ?? client).get<GetViewBulletinAttachmentFilenameResponses, GetViewBulletinAttachmentFilenameErrors, ThrowOnError>({ url: '/py/view/bulletin/attachment/{filename}', ...options });

/**
 * Get View Bulletin Thumbnail Filename
 *
 * Download
 */
export const getViewBulletinThumbnailFilename = <ThrowOnError extends boolean = false>(options: Options<GetViewBulletinThumbnailFilenameData, ThrowOnError>): RequestResult<GetViewBulletinThumbnailFilenameResponses, GetViewBulletinThumbnailFilenameErrors, ThrowOnError> => (options.client ?? client).get<GetViewBulletinThumbnailFilenameResponses, GetViewBulletinThumbnailFilenameErrors, ThrowOnError>({ url: '/py/view/bulletin/thumbnail/{filename}', ...options });

/**
 * Get Public Group Bulletins
 *
 * Get bulletins for a public group without requiring user login
 */
export const getPublicGroupBulletins = <ThrowOnError extends boolean = false>(options: Options<GetPublicGroupBulletinsData, ThrowOnError>): RequestResult<GetPublicGroupBulletinsResponses, GetPublicGroupBulletinsErrors, ThrowOnError> => (options.client ?? client).get<GetPublicGroupBulletinsResponses, GetPublicGroupBulletinsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/bulletins/group/{group_id}',
    ...options
});

/**
 * Get Police Services Group Public
 *
 * Get the public map info for a public group's org
 */
export const getPoliceServicesGroupPublic = <ThrowOnError extends boolean = false>(options: Options<GetPoliceServicesGroupPublicData, ThrowOnError>): RequestResult<GetPoliceServicesGroupPublicResponses, GetPoliceServicesGroupPublicErrors, ThrowOnError> => (options.client ?? client).get<GetPoliceServicesGroupPublicResponses, GetPoliceServicesGroupPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/police_services/group/{group_id}',
    ...options
});

/**
 * Get Bulletin Attachment Public
 *
 * Download bulletin attachment for public access without authentication
 */
export const getBulletinAttachmentPublic = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAttachmentPublicData, ThrowOnError>): RequestResult<GetBulletinAttachmentPublicResponses, GetBulletinAttachmentPublicErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAttachmentPublicResponses, GetBulletinAttachmentPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/bulletin/{bulletin_id}/attachment/{filename}',
    ...options
});

/**
 * Get Bulletin Thumbnail Public
 *
 * Download bulletin thumbnail for public access without authentication
 */
export const getBulletinThumbnailPublic = <ThrowOnError extends boolean = false>(options: Options<GetBulletinThumbnailPublicData, ThrowOnError>): RequestResult<GetBulletinThumbnailPublicResponses, GetBulletinThumbnailPublicErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinThumbnailPublicResponses, GetBulletinThumbnailPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/bulletin/{bulletin_id}/thumbnail/{filename}',
    ...options
});

/**
 * Get Bulletin Images
 *
 * Get images for a bulletin
 */
export const getBulletinImages = <ThrowOnError extends boolean = false>(options: Options<GetBulletinImagesData, ThrowOnError>): RequestResult<GetBulletinImagesResponses, GetBulletinImagesErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinImagesResponses, GetBulletinImagesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/bulletin/{bulletin_id}/images',
    ...options
});

/**
 * Get Public Bulletin Detail
 *
 * Get detailed bulletin information by its encrypted ID for public access without authentication
 */
export const getPublicBulletinDetail = <ThrowOnError extends boolean = false>(options: Options<GetPublicBulletinDetailData, ThrowOnError>): RequestResult<GetPublicBulletinDetailResponses, GetPublicBulletinDetailErrors, ThrowOnError> => (options.client ?? client).get<GetPublicBulletinDetailResponses, GetPublicBulletinDetailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/group/{group_id}/bulletin/{bulletin_id}/detail',
    ...options
});

/**
 * Get Crime Types
 *
 * Return all alert crime types grouped by category, ordered by sort_order.
 */
export const getCrimeTypes = <ThrowOnError extends boolean = false>(options?: Options<GetCrimeTypesData, ThrowOnError>): RequestResult<GetCrimeTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCrimeTypesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/crime-types',
    ...options
});

/**
 * Get Vehicle Makes Public
 *
 * Vehicle makes for the bulletin form's autocomplete.
 *
 * Served from `data_vehicle_make`, which holds the NHTSA vPIC catalogue as seeded by
 * migration. Nothing is fetched at request time — see `vehicle_reference`.
 */
export const getVehicleMakesPublic = <ThrowOnError extends boolean = false>(options?: Options<GetVehicleMakesPublicData, ThrowOnError>): RequestResult<GetVehicleMakesPublicResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetVehicleMakesPublicResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/vehicle-makes',
    ...options
});

/**
 * Get Vehicle Models Public
 *
 * Models for one make, resolved case-insensitively.
 *
 * An unrecognised make yields the sentinels alone rather than an error, which is what
 * lets the form fall back to `other` plus free text.
 */
export const getVehicleModelsPublic = <ThrowOnError extends boolean = false>(options: Options<GetVehicleModelsPublicData, ThrowOnError>): RequestResult<GetVehicleModelsPublicResponses, GetVehicleModelsPublicErrors, ThrowOnError> => (options.client ?? client).get<GetVehicleModelsPublicResponses, GetVehicleModelsPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/vehicle-makes/{make}/models',
    ...options
});

/**
 * Get Bulletin Types Public
 *
 * Return all bulletin types with translated names.
 */
export const getBulletinTypesPublic = <ThrowOnError extends boolean = false>(options?: Options<GetBulletinTypesPublicData, ThrowOnError>): RequestResult<GetBulletinTypesPublicResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBulletinTypesPublicResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/public/bulletin-types',
    ...options
});

/**
 * Get Bulletin Types
 *
 * Get all bulletin types with translations
 */
export const getBulletinTypes = <ThrowOnError extends boolean = false>(options?: Options<GetBulletinTypesData, ThrowOnError>): RequestResult<GetBulletinTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBulletinTypesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/types',
    ...options
});

/**
 * Create Bulletin Type
 */
export const createBulletinType = <ThrowOnError extends boolean = false>(options: Options<CreateBulletinTypeData, ThrowOnError>): RequestResult<CreateBulletinTypeResponses, CreateBulletinTypeErrors, ThrowOnError> => (options.client ?? client).post<CreateBulletinTypeResponses, CreateBulletinTypeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Resolution Reasons
 *
 * Get the allowed resolution reasons for a given bulletin type.
 */
export const getResolutionReasons = <ThrowOnError extends boolean = false>(options: Options<GetResolutionReasonsData, ThrowOnError>): RequestResult<GetResolutionReasonsResponses, GetResolutionReasonsErrors, ThrowOnError> => (options.client ?? client).get<GetResolutionReasonsResponses, GetResolutionReasonsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/resolution-reasons',
    ...options
});

/**
 * Delete Bulletin Type
 */
export const deleteBulletinType = <ThrowOnError extends boolean = false>(options: Options<DeleteBulletinTypeData, ThrowOnError>): RequestResult<DeleteBulletinTypeResponses, DeleteBulletinTypeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulletinTypeResponses, DeleteBulletinTypeErrors, ThrowOnError>({ url: '/py/bulletin/types/{type_id}', ...options });

/**
 * Patch Bulletin Type
 */
export const patchBulletinType = <ThrowOnError extends boolean = false>(options: Options<PatchBulletinTypeData, ThrowOnError>): RequestResult<PatchBulletinTypeResponses, PatchBulletinTypeErrors, ThrowOnError> => (options.client ?? client).patch<PatchBulletinTypeResponses, PatchBulletinTypeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/types/{type_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Crime Types Admin
 *
 * Get all alert crime types with full data for admin editing.
 */
export const getCrimeTypesAdmin = <ThrowOnError extends boolean = false>(options?: Options<GetCrimeTypesAdminData, ThrowOnError>): RequestResult<GetCrimeTypesAdminResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCrimeTypesAdminResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/crime-types',
    ...options
});

/**
 * Create Crime Type
 */
export const createCrimeType = <ThrowOnError extends boolean = false>(options: Options<CreateCrimeTypeData, ThrowOnError>): RequestResult<CreateCrimeTypeResponses, CreateCrimeTypeErrors, ThrowOnError> => (options.client ?? client).post<CreateCrimeTypeResponses, CreateCrimeTypeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/crime-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Crime Type
 */
export const deleteCrimeType = <ThrowOnError extends boolean = false>(options: Options<DeleteCrimeTypeData, ThrowOnError>): RequestResult<DeleteCrimeTypeResponses, DeleteCrimeTypeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCrimeTypeResponses, DeleteCrimeTypeErrors, ThrowOnError>({ url: '/py/bulletin/crime-types/{crime_id}', ...options });

/**
 * Patch Crime Type
 */
export const patchCrimeType = <ThrowOnError extends boolean = false>(options: Options<PatchCrimeTypeData, ThrowOnError>): RequestResult<PatchCrimeTypeResponses, PatchCrimeTypeErrors, ThrowOnError> => (options.client ?? client).patch<PatchCrimeTypeResponses, PatchCrimeTypeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/crime-types/{crime_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin
 *
 * Get chronological Bulletins with pagination
 *
 * Can be filtered by group_id parameter. Multiple group_ids can be specified
 * using group_id=1&group_id=2 format. Only bulletins that belong to any of
 * the specified groups (and that the user has access to) will be returned.
 */
export const getBulletin = <ThrowOnError extends boolean = false>(options?: Options<GetBulletinData, ThrowOnError>): RequestResult<GetBulletinResponses, GetBulletinErrors, ThrowOnError> => (options?.client ?? client).get<GetBulletinResponses, GetBulletinErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin',
    ...options
});

/**
 * Create Bulletin
 *
 * Create Bulletin.
 *
 * Blank unless `draft_token` names a RubiREPORT hand-off, in which case the occurrence's details,
 * its people and vehicles, and its evidence files are written onto the new row before it is
 * returned. Everything about reading that hand-off lives next to `get_bulletin_draft`, which is
 * the other reader of the same stub.
 */
export const createBulletin = <ThrowOnError extends boolean = false>(options: Options<CreateBulletinData, ThrowOnError>): RequestResult<CreateBulletinResponses, CreateBulletinErrors, ThrowOnError> => (options.client ?? client).put<CreateBulletinResponses, CreateBulletinErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Bulletins
 *
 * Search bulletins with optional filters including date ranges, geographic location, agency filtering, crime type filtering, and group filtering
 *
 * Can be filtered by group_id parameter. Multiple group_ids can be specified
 * using group_id=1&group_id=2 format. Only bulletins that belong to any of
 * the specified groups (and that the user has access to) will be returned.
 *
 * The associated_crime parameter allows filtering by specific crime types associated with bulletins.
 */
export const searchBulletins = <ThrowOnError extends boolean = false>(options?: Options<SearchBulletinsData, ThrowOnError>): RequestResult<SearchBulletinsResponses, SearchBulletinsErrors, ThrowOnError> => (options?.client ?? client).get<SearchBulletinsResponses, SearchBulletinsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/search',
    ...options
});

/**
 * Migrate
 *
 * Bulk index all bulletins to OpenSearch - returns detailed results including any failures
 */
export const migrate = <ThrowOnError extends boolean = false>(options?: Options<MigrateData, ThrowOnError>): RequestResult<MigrateResponses, unknown, ThrowOnError> => (options?.client ?? client).post<MigrateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/migrate',
    ...options
});

/**
 * Backfill Search Tsvector
 *
 * Build `search_tsvector` for every published bulletin that has none yet.
 *
 * Only missing rows are touched, so the call is safe to repeat and resumes where an
 * interrupted run stopped.
 */
export const backfillSearchTsvector = <ThrowOnError extends boolean = false>(options?: Options<BackfillSearchTsvectorData, ThrowOnError>): RequestResult<BackfillSearchTsvectorResponses, unknown, ThrowOnError> => (options?.client ?? client).post<BackfillSearchTsvectorResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/backfill_search_tsvector',
    ...options
});

/**
 * Get Bulletin Pins
 *
 * Get chronological Bulletins with pagination
 */
export const getBulletinPins = <ThrowOnError extends boolean = false>(options?: Options<GetBulletinPinsData, ThrowOnError>): RequestResult<GetBulletinPinsResponses, GetBulletinPinsErrors, ThrowOnError> => (options?.client ?? client).get<GetBulletinPinsResponses, GetBulletinPinsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/pin',
    ...options
});

/**
 * Delete Bulletin Id
 */
export const deleteBulletinId = <ThrowOnError extends boolean = false>(options: Options<DeleteBulletinIdData, ThrowOnError>): RequestResult<DeleteBulletinIdResponses, DeleteBulletinIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulletinIdResponses, DeleteBulletinIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}',
    ...options
});

/**
 * Get Bulletin By Id
 *
 * Get a Bulletin by ID
 */
export const getBulletinById = <ThrowOnError extends boolean = false>(options: Options<GetBulletinByIdData, ThrowOnError>): RequestResult<GetBulletinByIdResponses, GetBulletinByIdErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinByIdResponses, GetBulletinByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}',
    ...options
});

/**
 * Patch Bulletin Id
 *
 * Update a Bulletin by ID
 */
export const patchBulletinId = <ThrowOnError extends boolean = false>(options: Options<PatchBulletinIdData, ThrowOnError>): RequestResult<PatchBulletinIdResponses, PatchBulletinIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchBulletinIdResponses, PatchBulletinIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin Neighbors
 *
 * Get a Bulletin by ID
 */
export const getBulletinNeighbors = <ThrowOnError extends boolean = false>(options: Options<GetBulletinNeighborsData, ThrowOnError>): RequestResult<GetBulletinNeighborsResponses, GetBulletinNeighborsErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinNeighborsResponses, GetBulletinNeighborsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/neighbours',
    ...options
});

/**
 * Email Bulletin
 *
 * Email Bulletin
 */
export const emailBulletin = <ThrowOnError extends boolean = false>(options: Options<EmailBulletinData, ThrowOnError>): RequestResult<EmailBulletinResponses, EmailBulletinErrors, ThrowOnError> => (options.client ?? client).post<EmailBulletinResponses, EmailBulletinErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/send',
    ...options
});

/**
 * Batch Email Bulletins
 *
 * Batch Email Bulletins
 */
export const batchEmailBulletins = <ThrowOnError extends boolean = false>(options: Options<BatchEmailBulletinsData, ThrowOnError>): RequestResult<BatchEmailBulletinsResponses, BatchEmailBulletinsErrors, ThrowOnError> => (options.client ?? client).post<BatchEmailBulletinsResponses, BatchEmailBulletinsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/batch_send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch Email Bulletins Individual
 *
 * Send bulletins to individual email addresses.
 */
export const batchEmailBulletinsIndividual = <ThrowOnError extends boolean = false>(options: Options<BatchEmailBulletinsIndividualData, ThrowOnError>): RequestResult<BatchEmailBulletinsIndividualResponses, BatchEmailBulletinsIndividualErrors, ThrowOnError> => (options.client ?? client).post<BatchEmailBulletinsIndividualResponses, BatchEmailBulletinsIndividualErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/batch_send_individual',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Bulletin Pdf
 */
export const deleteBulletinPdf = <ThrowOnError extends boolean = false>(options: Options<DeleteBulletinPdfData, ThrowOnError>): RequestResult<DeleteBulletinPdfResponses, DeleteBulletinPdfErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulletinPdfResponses, DeleteBulletinPdfErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/pdf',
    ...options
});

/**
 * Download Bulletin Pdf
 *
 * Download an UploadedFile by ID
 */
export const downloadBulletinPdf = <ThrowOnError extends boolean = false>(options: Options<DownloadBulletinPdfData, ThrowOnError>): RequestResult<DownloadBulletinPdfResponses, DownloadBulletinPdfErrors, ThrowOnError> => (options.client ?? client).get<DownloadBulletinPdfResponses, DownloadBulletinPdfErrors, ThrowOnError>({ url: '/py/bulletin/{bulletin_id}/pdf', ...options });

/**
 * Upload Bulletin Pdf
 *
 * Create UploadedFile
 */
export const uploadBulletinPdf = <ThrowOnError extends boolean = false>(options: Options<UploadBulletinPdfData, ThrowOnError>): RequestResult<UploadBulletinPdfResponses, UploadBulletinPdfErrors, ThrowOnError> => (options.client ?? client).post<UploadBulletinPdfResponses, UploadBulletinPdfErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/pdf',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Extract Text From Pdf
 *
 * Extract text from PDF and analyze it, returning a JSON object
 */
export const extractTextFromPdf = <ThrowOnError extends boolean = false>(options: Options<ExtractTextFromPdfData, ThrowOnError>): RequestResult<ExtractTextFromPdfResponses, ExtractTextFromPdfErrors, ThrowOnError> => (options.client ?? client).post<ExtractTextFromPdfResponses, ExtractTextFromPdfErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/py/bulletin/text_from_pdf',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Extract Images From Pdf
 *
 * Extract images from PDF and upload them to bulletin
 */
export const extractImagesFromPdf = <ThrowOnError extends boolean = false>(options: Options<ExtractImagesFromPdfData, ThrowOnError>): RequestResult<ExtractImagesFromPdfResponses, ExtractImagesFromPdfErrors, ThrowOnError> => (options.client ?? client).post<ExtractImagesFromPdfResponses, ExtractImagesFromPdfErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/images_from_pdf',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Upload Bulletin Attachment
 */
export const uploadBulletinAttachment = <ThrowOnError extends boolean = false>(options: Options<UploadBulletinAttachmentData, ThrowOnError>): RequestResult<UploadBulletinAttachmentResponses, UploadBulletinAttachmentErrors, ThrowOnError> => (options.client ?? client).post<UploadBulletinAttachmentResponses, UploadBulletinAttachmentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/attachment',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Post Bulletin Create Bulletin Url Signed Params
 */
export const postBulletinCreateBulletinUrlSignedParams = <ThrowOnError extends boolean = false>(options: Options<PostBulletinCreateBulletinUrlSignedParamsData, ThrowOnError>): RequestResult<PostBulletinCreateBulletinUrlSignedParamsResponses, PostBulletinCreateBulletinUrlSignedParamsErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinCreateBulletinUrlSignedParamsResponses, PostBulletinCreateBulletinUrlSignedParamsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/create_bulletin_url_signed_params',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Bulletin Attachment
 */
export const deleteBulletinAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteBulletinAttachmentData, ThrowOnError>): RequestResult<DeleteBulletinAttachmentResponses, DeleteBulletinAttachmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulletinAttachmentResponses, DeleteBulletinAttachmentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/attachment/{filename}',
    ...options
});

/**
 * Get Bulletin Attachment
 */
export const getBulletinAttachment = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAttachmentData, ThrowOnError>): RequestResult<GetBulletinAttachmentResponses, GetBulletinAttachmentErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAttachmentResponses, GetBulletinAttachmentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/attachment/{filename}',
    ...options
});

/**
 * Patch Bulletin Id Attachment Filename
 */
export const patchBulletinIdAttachmentFilename = <ThrowOnError extends boolean = false>(options: Options<PatchBulletinIdAttachmentFilenameData, ThrowOnError>): RequestResult<PatchBulletinIdAttachmentFilenameResponses, PatchBulletinIdAttachmentFilenameErrors, ThrowOnError> => (options.client ?? client).patch<PatchBulletinIdAttachmentFilenameResponses, PatchBulletinIdAttachmentFilenameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/attachment/{filename}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin Thumbnail
 */
export const getBulletinThumbnail = <ThrowOnError extends boolean = false>(options: Options<GetBulletinThumbnailData, ThrowOnError>): RequestResult<GetBulletinThumbnailResponses, GetBulletinThumbnailErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinThumbnailResponses, GetBulletinThumbnailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/thumbnail/{filename}',
    ...options
});

/**
 * Post Bulletin Group Expire Date
 *
 * Update the expire date of an existing bulletin.
 */
export const postBulletinGroupExpireDate = <ThrowOnError extends boolean = false>(options: Options<PostBulletinGroupExpireDateData, ThrowOnError>): RequestResult<PostBulletinGroupExpireDateResponses, PostBulletinGroupExpireDateErrors, ThrowOnError> => (options.client ?? client).patch<PostBulletinGroupExpireDateResponses, PostBulletinGroupExpireDateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/group/{group_id}/expire_date',
    ...options
});

/**
 * Post Bulk Update Groups
 */
export const postBulkUpdateGroups = <ThrowOnError extends boolean = false>(options: Options<PostBulkUpdateGroupsData, ThrowOnError>): RequestResult<PostBulkUpdateGroupsResponses, PostBulkUpdateGroupsErrors, ThrowOnError> => (options.client ?? client).post<PostBulkUpdateGroupsResponses, PostBulkUpdateGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/bulk_update_groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin Id Groups
 *
 * Get BulletinMembership groups for Bulletin
 */
export const getBulletinIdGroups = <ThrowOnError extends boolean = false>(options: Options<GetBulletinIdGroupsData, ThrowOnError>): RequestResult<GetBulletinIdGroupsResponses, GetBulletinIdGroupsErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinIdGroupsResponses, GetBulletinIdGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/groups',
    ...options
});

/**
 * Get Bulletin Access Me
 */
export const getBulletinAccessMe = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAccessMeData, ThrowOnError>): RequestResult<GetBulletinAccessMeResponses, GetBulletinAccessMeErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAccessMeResponses, GetBulletinAccessMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/access/me',
    ...options
});

/**
 * Get Bulletin Access My Groups
 */
export const getBulletinAccessMyGroups = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAccessMyGroupsData, ThrowOnError>): RequestResult<GetBulletinAccessMyGroupsResponses, GetBulletinAccessMyGroupsErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAccessMyGroupsResponses, GetBulletinAccessMyGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/access/my_groups',
    ...options
});

/**
 * Get Bulletin Access Other Groups
 */
export const getBulletinAccessOtherGroups = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAccessOtherGroupsData, ThrowOnError>): RequestResult<GetBulletinAccessOtherGroupsResponses, GetBulletinAccessOtherGroupsErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAccessOtherGroupsResponses, GetBulletinAccessOtherGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/access/other_groups',
    ...options
});

/**
 * Get Bulletin Access Group
 *
 * Get bulletin access permissions for a specific group
 */
export const getBulletinAccessGroup = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAccessGroupData, ThrowOnError>): RequestResult<GetBulletinAccessGroupResponses, GetBulletinAccessGroupErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAccessGroupResponses, GetBulletinAccessGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/access/group/{group_id}',
    ...options
});

/**
 * Post Bulletin Add Group
 */
export const postBulletinAddGroup = <ThrowOnError extends boolean = false>(options: Options<PostBulletinAddGroupData, ThrowOnError>): RequestResult<PostBulletinAddGroupResponses, PostBulletinAddGroupErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinAddGroupResponses, PostBulletinAddGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/add_group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Bulletin Add Groups
 */
export const postBulletinAddGroups = <ThrowOnError extends boolean = false>(options: Options<PostBulletinAddGroupsData, ThrowOnError>): RequestResult<PostBulletinAddGroupsResponses, PostBulletinAddGroupsErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinAddGroupsResponses, PostBulletinAddGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/add_groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin My Access
 *
 * Get the current user's personal access permissions for a bulletin.
 *
 * Returns:
 * - can_view: whether the user can view the bulletin
 * - can_modify: whether the user can modify bulletin content
 * - is_owner: whether the user is the bulletin owner
 */
export const getBulletinMyAccess = <ThrowOnError extends boolean = false>(options: Options<GetBulletinMyAccessData, ThrowOnError>): RequestResult<GetBulletinMyAccessResponses, GetBulletinMyAccessErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinMyAccessResponses, GetBulletinMyAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/my_access',
    ...options
});

/**
 * Get Bulletin Access Management
 *
 * Get comprehensive access management data for a bulletin.
 *
 * Returns all information needed for the access management UI:
 * - Groups the user belongs to + groups with existing bulletin access
 * - For each group: membership info, bulletin access, share permissions
 *
 * Use GET /{bulletin_id}/my_access for the user's personal permissions.
 * Use GET /{bulletin_id}/search_groups?q=... to search for additional groups.
 */
export const getBulletinAccessManagement = <ThrowOnError extends boolean = false>(options: Options<GetBulletinAccessManagementData, ThrowOnError>): RequestResult<GetBulletinAccessManagementResponses, GetBulletinAccessManagementErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinAccessManagementResponses, GetBulletinAccessManagementErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/access_management',
    ...options
});

/**
 * Search Bulletin Groups
 *
 * Search for groups to share a bulletin with.
 *
 * Searches groups by name (case-insensitive contains match).
 * Returns GroupAccessInfo with enriched share/remove permission data.
 */
export const searchBulletinGroups = <ThrowOnError extends boolean = false>(options: Options<SearchBulletinGroupsData, ThrowOnError>): RequestResult<SearchBulletinGroupsResponses, SearchBulletinGroupsErrors, ThrowOnError> => (options.client ?? client).get<SearchBulletinGroupsResponses, SearchBulletinGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/search_groups',
    ...options
});

/**
 * Post Bulletin Remove Group
 */
export const postBulletinRemoveGroup = <ThrowOnError extends boolean = false>(options: Options<PostBulletinRemoveGroupData, ThrowOnError>): RequestResult<PostBulletinRemoveGroupResponses, PostBulletinRemoveGroupErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinRemoveGroupResponses, PostBulletinRemoveGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/remove_group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Bulletin Membership Permission
 *
 * Update BulletinMembership permission level (read/full) for existing membership
 * This should not need share process because this group already have access to the bulletin
 */
export const updateBulletinMembershipPermission = <ThrowOnError extends boolean = false>(options: Options<UpdateBulletinMembershipPermissionData, ThrowOnError>): RequestResult<UpdateBulletinMembershipPermissionResponses, UpdateBulletinMembershipPermissionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBulletinMembershipPermissionResponses, UpdateBulletinMembershipPermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/membership/permission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Tag Request
 */
export const createTagRequest = <ThrowOnError extends boolean = false>(options: Options<CreateTagRequestData, ThrowOnError>): RequestResult<CreateTagRequestResponses, CreateTagRequestErrors, ThrowOnError> => (options.client ?? client).put<CreateTagRequestResponses, CreateTagRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Tag
 */
export const deleteTag = <ThrowOnError extends boolean = false>(options: Options<DeleteTagData, ThrowOnError>): RequestResult<DeleteTagResponses, DeleteTagErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTagResponses, DeleteTagErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/tag/{tag_id}',
    ...options
});

/**
 * Patch Tag Request
 */
export const patchTagRequest = <ThrowOnError extends boolean = false>(options: Options<PatchTagRequestData, ThrowOnError>): RequestResult<PatchTagRequestResponses, PatchTagRequestErrors, ThrowOnError> => (options.client ?? client).patch<PatchTagRequestResponses, PatchTagRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/tag/{tag_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Bulletin Resolution
 *
 * Create a BulletinResolution
 */
export const createBulletinResolution = <ThrowOnError extends boolean = false>(options: Options<CreateBulletinResolutionData, ThrowOnError>): RequestResult<CreateBulletinResolutionResponses, CreateBulletinResolutionErrors, ThrowOnError> => (options.client ?? client).put<CreateBulletinResolutionResponses, CreateBulletinResolutionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Bulletin Resolution
 *
 * Delete a BulletinResolution
 */
export const deleteBulletinResolution = <ThrowOnError extends boolean = false>(options: Options<DeleteBulletinResolutionData, ThrowOnError>): RequestResult<DeleteBulletinResolutionResponses, DeleteBulletinResolutionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulletinResolutionResponses, DeleteBulletinResolutionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution/{resolution_id}',
    ...options
});

/**
 * Patch Bulletin Resolution
 *
 * Patch a BulletinResolution
 */
export const patchBulletinResolution = <ThrowOnError extends boolean = false>(options: Options<PatchBulletinResolutionData, ThrowOnError>): RequestResult<PatchBulletinResolutionResponses, PatchBulletinResolutionErrors, ThrowOnError> => (options.client ?? client).patch<PatchBulletinResolutionResponses, PatchBulletinResolutionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution/{resolution_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Resolution Attachment
 */
export const uploadResolutionAttachment = <ThrowOnError extends boolean = false>(options: Options<UploadResolutionAttachmentData, ThrowOnError>): RequestResult<UploadResolutionAttachmentResponses, UploadResolutionAttachmentErrors, ThrowOnError> => (options.client ?? client).post<UploadResolutionAttachmentResponses, UploadResolutionAttachmentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution/{resolution_id}/attachment',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Resolution Attachment
 */
export const deleteResolutionAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteResolutionAttachmentData, ThrowOnError>): RequestResult<DeleteResolutionAttachmentResponses, DeleteResolutionAttachmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteResolutionAttachmentResponses, DeleteResolutionAttachmentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution/{resolution_id}/attachment/{filename}',
    ...options
});

/**
 * Download Resolution Attachment
 */
export const downloadResolutionAttachment = <ThrowOnError extends boolean = false>(options: Options<DownloadResolutionAttachmentData, ThrowOnError>): RequestResult<DownloadResolutionAttachmentResponses, DownloadResolutionAttachmentErrors, ThrowOnError> => (options.client ?? client).get<DownloadResolutionAttachmentResponses, DownloadResolutionAttachmentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution/{resolution_id}/attachment/{filename}',
    ...options
});

/**
 * Download Resolution Thumbnail
 */
export const downloadResolutionThumbnail = <ThrowOnError extends boolean = false>(options: Options<DownloadResolutionThumbnailData, ThrowOnError>): RequestResult<DownloadResolutionThumbnailResponses, DownloadResolutionThumbnailErrors, ThrowOnError> => (options.client ?? client).get<DownloadResolutionThumbnailResponses, DownloadResolutionThumbnailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/resolution/{resolution_id}/thumbnail/{filename}',
    ...options
});

/**
 * Admin Flag Bulletin Multiple
 */
export const adminFlagBulletinMultiple = <ThrowOnError extends boolean = false>(options: Options<AdminFlagBulletinMultipleData, ThrowOnError>): RequestResult<AdminFlagBulletinMultipleResponses, AdminFlagBulletinMultipleErrors, ThrowOnError> => (options.client ?? client).post<AdminFlagBulletinMultipleResponses, AdminFlagBulletinMultipleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/flag/admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Unflag Bulletin Multiple
 */
export const adminUnflagBulletinMultiple = <ThrowOnError extends boolean = false>(options: Options<AdminUnflagBulletinMultipleData, ThrowOnError>): RequestResult<AdminUnflagBulletinMultipleResponses, AdminUnflagBulletinMultipleErrors, ThrowOnError> => (options.client ?? client).post<AdminUnflagBulletinMultipleResponses, AdminUnflagBulletinMultipleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/{bulletin_id}/unflag/admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin Draft
 *
 * Get bulletin draft data by token (one-time use).
 *
 * Retrieves bulletin creation data stored to avoid URL length issues when
 * OpenAI generates long content. The draft is deleted after retrieval.
 *
 * The old wizard's reader: it is handed the values and builds the bulletin itself, so the stub is
 * spent the moment they are returned. `PUT /bulletin` with a `draft_token` is the other half of
 * that trade — it creates the row here and hands back a bulletin instead.
 *
 * Raises:
 * 400: Invalid token format
 * 404: Draft not found
 * 410: Draft expired
 */
export const getBulletinDraft = <ThrowOnError extends boolean = false>(options: Options<GetBulletinDraftData, ThrowOnError>): RequestResult<GetBulletinDraftResponses, GetBulletinDraftErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinDraftResponses, GetBulletinDraftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin/draft/{token}',
    ...options
});

/**
 * Get Mailing Lists
 *
 * Get MailingLists belonging to current user
 */
export const getMailingLists = <ThrowOnError extends boolean = false>(options?: Options<GetMailingListsData, ThrowOnError>): RequestResult<GetMailingListsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMailingListsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/mailing_list',
    ...options
});

/**
 * Create Mailing List
 *
 * Create MailingList
 */
export const createMailingList = <ThrowOnError extends boolean = false>(options: Options<CreateMailingListData, ThrowOnError>): RequestResult<CreateMailingListResponses, CreateMailingListErrors, ThrowOnError> => (options.client ?? client).put<CreateMailingListResponses, CreateMailingListErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/mailing_list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Mailing List
 *
 * Delete MailingList
 */
export const deleteMailingList = <ThrowOnError extends boolean = false>(options: Options<DeleteMailingListData, ThrowOnError>): RequestResult<DeleteMailingListResponses, DeleteMailingListErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMailingListResponses, DeleteMailingListErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/mailing_list/{id}',
    ...options
});

/**
 * Get Mailing List By Id
 *
 * Get MailingList by ID
 */
export const getMailingListById = <ThrowOnError extends boolean = false>(options: Options<GetMailingListByIdData, ThrowOnError>): RequestResult<GetMailingListByIdResponses, GetMailingListByIdErrors, ThrowOnError> => (options.client ?? client).get<GetMailingListByIdResponses, GetMailingListByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/mailing_list/{id}',
    ...options
});

/**
 * Insert Item To Mailing List
 *
 * Insert email item into MailingList
 */
export const insertItemToMailingList = <ThrowOnError extends boolean = false>(options: Options<InsertItemToMailingListData, ThrowOnError>): RequestResult<InsertItemToMailingListResponses, InsertItemToMailingListErrors, ThrowOnError> => (options.client ?? client).post<InsertItemToMailingListResponses, InsertItemToMailingListErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/mailing_list/{id}/insert_item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Item From Mailing List
 *
 * Remove email item from MailingList
 */
export const removeItemFromMailingList = <ThrowOnError extends boolean = false>(options: Options<RemoveItemFromMailingListData, ThrowOnError>): RequestResult<RemoveItemFromMailingListResponses, RemoveItemFromMailingListErrors, ThrowOnError> => (options.client ?? client).post<RemoveItemFromMailingListResponses, RemoveItemFromMailingListErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/mailing_list/{id}/remove_item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Police Services
 *
 * Get PoliceServices
 */
export const getPoliceServices = <ThrowOnError extends boolean = false>(options?: Options<GetPoliceServicesData, ThrowOnError>): RequestResult<GetPoliceServicesResponses, GetPoliceServicesErrors, ThrowOnError> => (options?.client ?? client).get<GetPoliceServicesResponses, GetPoliceServicesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/police_service',
    ...options
});

/**
 * Get Org Config
 *
 * Get organization's alert configuration
 */
export const getOrgConfig = <ThrowOnError extends boolean = false>(options: Options<GetOrgConfigData, ThrowOnError>): RequestResult<GetOrgConfigResponses, GetOrgConfigErrors, ThrowOnError> => (options.client ?? client).get<GetOrgConfigResponses, GetOrgConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/police_service/{rubi_org_id}/config',
    ...options
});

/**
 * Create Org Config
 *
 * Create organization's alert configuration
 */
export const createOrgConfig = <ThrowOnError extends boolean = false>(options: Options<CreateOrgConfigData, ThrowOnError>): RequestResult<CreateOrgConfigResponses, CreateOrgConfigErrors, ThrowOnError> => (options.client ?? client).post<CreateOrgConfigResponses, CreateOrgConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/police_service/org_config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Org Config
 *
 * Delete organization's alert configuration
 */
export const deleteOrgConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteOrgConfigData, ThrowOnError>): RequestResult<DeleteOrgConfigResponses, DeleteOrgConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrgConfigResponses, DeleteOrgConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/police_service/org_config/{rubi_org_id}',
    ...options
});

/**
 * Update Org Config
 *
 * Update organization's alert configuration
 */
export const updateOrgConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateOrgConfigData, ThrowOnError>): RequestResult<UpdateOrgConfigResponses, UpdateOrgConfigErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrgConfigResponses, UpdateOrgConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/police_service/org_config/{rubi_org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Groups
 *
 * Get Groups
 *
 * Args:
 * me: Filter groups where the current user is a member
 * user_id: Optional filter by user membership
 * is_public: Optional filter by public status
 * group_ids: Optional filter by list of Group.id, e.g. '&group_ids=1,2,3'
 * group_name: Optional filter by Group.name text, e.g. '&group_name=ali' -> Group(name = 'alistair@tryrubicon.com', ...)
 */
export const getGroups = <ThrowOnError extends boolean = false>(options?: Options<GetGroupsData, ThrowOnError>): RequestResult<GetGroupsResponses, GetGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GetGroupsResponses, GetGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group',
    ...options
});

/**
 * Put Group
 *
 * Create a group
 */
export const putGroup = <ThrowOnError extends boolean = false>(options: Options<PutGroupData, ThrowOnError>): RequestResult<PutGroupResponses, PutGroupErrors, ThrowOnError> => (options.client ?? client).put<PutGroupResponses, PutGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Group By Id
 *
 * Get a group by ID
 */
export const getGroupById = <ThrowOnError extends boolean = false>(options: Options<GetGroupByIdData, ThrowOnError>): RequestResult<GetGroupByIdResponses, GetGroupByIdErrors, ThrowOnError> => (options.client ?? client).get<GetGroupByIdResponses, GetGroupByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}',
    ...options
});

/**
 * Patch Group
 *
 * Update a group's settings
 */
export const patchGroup = <ThrowOnError extends boolean = false>(options: Options<PatchGroupData, ThrowOnError>): RequestResult<PatchGroupResponses, PatchGroupErrors, ThrowOnError> => (options.client ?? client).patch<PatchGroupResponses, PatchGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Group Members
 *
 * Get members of a group.
 *
 * Args:
 * permission: Optional. Filter to members that have this permission set to True.
 * Requires manage_members or manage_admins. Must be one of the valid
 * permission field names.
 */
export const getGroupMembers = <ThrowOnError extends boolean = false>(options: Options<GetGroupMembersData, ThrowOnError>): RequestResult<GetGroupMembersResponses, GetGroupMembersErrors, ThrowOnError> => (options.client ?? client).get<GetGroupMembersResponses, GetGroupMembersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/members',
    ...options
});

/**
 * Get Non Members
 *
 * Get users that are not members of a group and return their alert membership state
 */
export const getNonMembers = <ThrowOnError extends boolean = false>(options: Options<GetNonMembersData, ThrowOnError>): RequestResult<GetNonMembersResponses, GetNonMembersErrors, ThrowOnError> => (options.client ?? client).get<GetNonMembersResponses, GetNonMembersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/non_members',
    ...options
});

/**
 * Get Group Users
 *
 * Get all users from an org with their alert and group membership state.
 *
 * Args:
 * group_id: The group to check membership against
 * org_id: Optional org UUID to filter by. Defaults to the requesting user's org.
 */
export const getGroupUsers = <ThrowOnError extends boolean = false>(options: Options<GetGroupUsersData, ThrowOnError>): RequestResult<GetGroupUsersResponses, GetGroupUsersErrors, ThrowOnError> => (options.client ?? client).get<GetGroupUsersResponses, GetGroupUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/users',
    ...options
});

/**
 * Post Group Id Add Member
 *
 * Add group member to PoliceService
 */
export const postGroupIdAddMember = <ThrowOnError extends boolean = false>(options: Options<PostGroupIdAddMemberData, ThrowOnError>): RequestResult<PostGroupIdAddMemberResponses, PostGroupIdAddMemberErrors, ThrowOnError> => (options.client ?? client).post<PostGroupIdAddMemberResponses, PostGroupIdAddMemberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/add_member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Group Id Remove Member
 *
 * Remove group member from group
 */
export const postGroupIdRemoveMember = <ThrowOnError extends boolean = false>(options: Options<PostGroupIdRemoveMemberData, ThrowOnError>): RequestResult<PostGroupIdRemoveMemberResponses, PostGroupIdRemoveMemberErrors, ThrowOnError> => (options.client ?? client).post<PostGroupIdRemoveMemberResponses, PostGroupIdRemoveMemberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/remove_member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Group Member
 *
 * Get a specific member of a group
 */
export const getGroupMember = <ThrowOnError extends boolean = false>(options: Options<GetGroupMemberData, ThrowOnError>): RequestResult<GetGroupMemberResponses, GetGroupMemberErrors, ThrowOnError> => (options.client ?? client).get<GetGroupMemberResponses, GetGroupMemberErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/member/{user_id}',
    ...options
});

/**
 * Get Group Member Permissions
 *
 * Get permissions for a specific member of a group
 */
export const getGroupMemberPermissions = <ThrowOnError extends boolean = false>(options: Options<GetGroupMemberPermissionsData, ThrowOnError>): RequestResult<GetGroupMemberPermissionsResponses, GetGroupMemberPermissionsErrors, ThrowOnError> => (options.client ?? client).get<GetGroupMemberPermissionsResponses, GetGroupMemberPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/member/{user_id}/permissions',
    ...options
});

/**
 * Update Group Member Permissions
 *
 * Update permissions for a specific member of a group
 *
 * permissions:
 * - bypass_moderation: can bypass moderation for the user
 * - moderate_bulletin_admittance: can moderate bulletin admittance for the user
 * - manage_members: can manage members of the group
 * - manage_admins: can manage admins of the group
 * - flag_bulletin: can flag bulletins for the user
 * - manage_group: can manage the group
 * - can_share_bulletin: can share bulletins with the user
 * - can_revoke_bulletin: can revoke bulletins from the user
 * - can_promote_content_moderators: can promote content moderators for the user
 * - can_transfer_bulletin_to_another_group: can transfer bulletin to another group
 * - can_moderate_content: can moderate content
 *
 * Permission requirements:
 * User needs manage_admins permission to modify permissions of other users
 * User cannot revoke their own manage_admins permission
 */
export const updateGroupMemberPermissions = <ThrowOnError extends boolean = false>(options: Options<UpdateGroupMemberPermissionsData, ThrowOnError>): RequestResult<UpdateGroupMemberPermissionsResponses, UpdateGroupMemberPermissionsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateGroupMemberPermissionsResponses, UpdateGroupMemberPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/member/{user_id}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Group Bulletin Shares
 *
 * Get pending bulletin shares for a specific group (where this group is the destination).
 */
export const getGroupBulletinShares = <ThrowOnError extends boolean = false>(options: Options<GetGroupBulletinSharesData, ThrowOnError>): RequestResult<GetGroupBulletinSharesResponses, GetGroupBulletinSharesErrors, ThrowOnError> => (options.client ?? client).get<GetGroupBulletinSharesResponses, GetGroupBulletinSharesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/bulletin_shares/pending',
    ...options
});

/**
 * Get Group Stats
 *
 * Get stats for a specific group
 */
export const getGroupStats = <ThrowOnError extends boolean = false>(options: Options<GetGroupStatsData, ThrowOnError>): RequestResult<GetGroupStatsResponses, GetGroupStatsErrors, ThrowOnError> => (options.client ?? client).get<GetGroupStatsResponses, GetGroupStatsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/stats',
    ...options
});

/**
 * Get Bulletin Type Bypasses
 *
 * Get all bulletin type bypasses for a group
 */
export const getBulletinTypeBypasses = <ThrowOnError extends boolean = false>(options: Options<GetBulletinTypeBypassesData, ThrowOnError>): RequestResult<GetBulletinTypeBypassesResponses, GetBulletinTypeBypassesErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinTypeBypassesResponses, GetBulletinTypeBypassesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/bulletin-type-bypasses',
    ...options
});

/**
 * Create Bulletin Type Bypass
 *
 * Create a bulletin type bypass for a group
 */
export const createBulletinTypeBypass = <ThrowOnError extends boolean = false>(options: Options<CreateBulletinTypeBypassData, ThrowOnError>): RequestResult<CreateBulletinTypeBypassResponses, CreateBulletinTypeBypassErrors, ThrowOnError> => (options.client ?? client).post<CreateBulletinTypeBypassResponses, CreateBulletinTypeBypassErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/bulletin-type-bypasses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Bulletin Type Bypass
 *
 * Delete a bulletin type bypass
 */
export const deleteBulletinTypeBypass = <ThrowOnError extends boolean = false>(options: Options<DeleteBulletinTypeBypassData, ThrowOnError>): RequestResult<DeleteBulletinTypeBypassResponses, DeleteBulletinTypeBypassErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBulletinTypeBypassResponses, DeleteBulletinTypeBypassErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/group/{group_id}/bulletin-type-bypasses/{bypass_id}',
    ...options
});

/**
 * Get User Me Groups
 *
 * Get active User's Groups
 */
export const getUserMeGroups = <ThrowOnError extends boolean = false>(options?: Options<GetUserMeGroupsData, ThrowOnError>): RequestResult<GetUserMeGroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserMeGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/me/groups',
    ...options
});

/**
 * Get User Public Groups
 *
 * Get Public Groups which the user's police service has
 */
export const getUserPublicGroups = <ThrowOnError extends boolean = false>(options?: Options<GetUserPublicGroupsData, ThrowOnError>): RequestResult<GetUserPublicGroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserPublicGroupsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/me/public_groups',
    ...options
});

/**
 * Allow Alert Access
 */
export const allowAlertAccess = <ThrowOnError extends boolean = false>(options: Options<AllowAlertAccessData, ThrowOnError>): RequestResult<AllowAlertAccessResponses, AllowAlertAccessErrors, ThrowOnError> => (options.client ?? client).post<AllowAlertAccessResponses, AllowAlertAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/user/{user_id}/alert_access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Bulletin Share
 *
 * List bulletin shares visible to the given user (default: current user).
 *
 * With pending=True, restricts to unexpired shares in groups where the user has
 * moderate_bulletin_admittance.
 * Without pending, returns all shares for groups the user is a member of.
 * total_count is the number of matching shares before offset/limit, so limit=0
 * returns just the count.
 */
export const listBulletinShare = <ThrowOnError extends boolean = false>(options?: Options<ListBulletinShareData, ThrowOnError>): RequestResult<ListBulletinShareResponses, ListBulletinShareErrors, ThrowOnError> => (options?.client ?? client).get<ListBulletinShareResponses, ListBulletinShareErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share',
    ...options
});

/**
 * Post Bulletin Share
 *
 * Creates a new BulletinShare entry to share a bulletin with another group.
 * If the destination group does not require admittance moderation, the bulletin will be directly added to the group.
 * If the destination group requires admittance moderation and the user has moderation rights, the bulletin will be directly added.
 * Otherwise, a share request will be created for moderators to review.
 */
export const postBulletinShare = <ThrowOnError extends boolean = false>(options: Options<PostBulletinShareData, ThrowOnError>): RequestResult<PostBulletinShareResponses, PostBulletinShareErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinShareResponses, PostBulletinShareErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Bulletin Share Admit
 */
export const postBulletinShareAdmit = <ThrowOnError extends boolean = false>(options: Options<PostBulletinShareAdmitData, ThrowOnError>): RequestResult<PostBulletinShareAdmitResponses, PostBulletinShareAdmitErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinShareAdmitResponses, PostBulletinShareAdmitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share/{bulletin_share_id}/admit',
    ...options
});

/**
 * Post Bulletin Share Reject
 */
export const postBulletinShareReject = <ThrowOnError extends boolean = false>(options: Options<PostBulletinShareRejectData, ThrowOnError>): RequestResult<PostBulletinShareRejectResponses, PostBulletinShareRejectErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinShareRejectResponses, PostBulletinShareRejectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share/{bulletin_share_id}/reject',
    ...options
});

/**
 * Post Bulletin Share Revoke
 *
 * Revoke a bulletin share request. This allows the source user or someone with
 * appropriate permissions in the source group to revoke an outgoing share request.
 */
export const postBulletinShareRevoke = <ThrowOnError extends boolean = false>(options: Options<PostBulletinShareRevokeData, ThrowOnError>): RequestResult<PostBulletinShareRevokeResponses, PostBulletinShareRevokeErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinShareRevokeResponses, PostBulletinShareRevokeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share/{bulletin_share_id}/revoke',
    ...options
});

/**
 * Get Bulletin Share
 *
 * Get a specific bulletin share with all related information.
 *
 * Args:
 * bulletin_share_id (int): The ID of the bulletin share to retrieve
 * db (AsyncSession, optional): Database session. Defaults to DDb.
 * cfg (Configuration, optional): App configuration. Defaults to DConfiguration.
 * user (AlertUser, optional): Current authenticated user. Defaults to DActiveUser.
 *
 * Returns:
 * BulletinShareListResource: The bulletin share with all related information
 *
 * Raises:
 * NotFound: If the bulletin share is not found
 * BadRequest: If the user does not have permission to view this bulletin share
 */
export const getBulletinShare = <ThrowOnError extends boolean = false>(options: Options<GetBulletinShareData, ThrowOnError>): RequestResult<GetBulletinShareResponses, GetBulletinShareErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinShareResponses, GetBulletinShareErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share/{bulletin_share_id}',
    ...options
});

/**
 * Patch Bulletin Share
 */
export const patchBulletinShare = <ThrowOnError extends boolean = false>(options: Options<PatchBulletinShareData, ThrowOnError>): RequestResult<PatchBulletinShareResponses, PatchBulletinShareErrors, ThrowOnError> => (options.client ?? client).patch<PatchBulletinShareResponses, PatchBulletinShareErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share/{bulletin_share_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin Shares By Bulletin Id
 *
 * Get all bulletin shares for a specific bulletin.
 *
 * Args:
 * bulletin_id (int): The ID of the bulletin to get shares for
 * db (AsyncSession, optional): Database session. Defaults to DDb.
 * cfg (Configuration, optional): App configuration. Defaults to DConfiguration.
 * user (AlertUser, optional): Current authenticated user. Defaults to DActiveUser.
 * accept_language (str, optional): Accept language header. Defaults to DAcceptLanguage.
 *
 * Returns:
 * BulletinShareListResponse: List of bulletin shares for the specified bulletin
 *
 * Raises:
 * NotFound: If the bulletin is not found or user has no access
 * Unauthorized: If the user doesn't have permission to view bulletin shares
 */
export const getBulletinSharesByBulletinId = <ThrowOnError extends boolean = false>(options: Options<GetBulletinSharesByBulletinIdData, ThrowOnError>): RequestResult<GetBulletinSharesByBulletinIdResponses, GetBulletinSharesByBulletinIdErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinSharesByBulletinIdResponses, GetBulletinSharesByBulletinIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_share/bulletin/{bulletin_id}',
    ...options
});

/**
 * List Bulletin Scope Change Request
 */
export const listBulletinScopeChangeRequest = <ThrowOnError extends boolean = false>(options?: Options<ListBulletinScopeChangeRequestData, ThrowOnError>): RequestResult<ListBulletinScopeChangeRequestResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListBulletinScopeChangeRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_scope_change_request',
    ...options
});

/**
 * Post Bulletin Scope Change Request
 */
export const postBulletinScopeChangeRequest = <ThrowOnError extends boolean = false>(options: Options<PostBulletinScopeChangeRequestData, ThrowOnError>): RequestResult<PostBulletinScopeChangeRequestResponses, PostBulletinScopeChangeRequestErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinScopeChangeRequestResponses, PostBulletinScopeChangeRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_scope_change_request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulletin Scope Change Request
 */
export const getBulletinScopeChangeRequest = <ThrowOnError extends boolean = false>(options: Options<GetBulletinScopeChangeRequestData, ThrowOnError>): RequestResult<GetBulletinScopeChangeRequestResponses, GetBulletinScopeChangeRequestErrors, ThrowOnError> => (options.client ?? client).get<GetBulletinScopeChangeRequestResponses, GetBulletinScopeChangeRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_scope_change_request/{bulletin_scope_change_request_id}',
    ...options
});

/**
 * Post Bulletin Scope Change Request Approve
 */
export const postBulletinScopeChangeRequestApprove = <ThrowOnError extends boolean = false>(options: Options<PostBulletinScopeChangeRequestApproveData, ThrowOnError>): RequestResult<PostBulletinScopeChangeRequestApproveResponses, PostBulletinScopeChangeRequestApproveErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinScopeChangeRequestApproveResponses, PostBulletinScopeChangeRequestApproveErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_scope_change_request/{bulletin_scope_change_request_id}/approve',
    ...options
});

/**
 * Post Bulletin Scope Change Request Reject
 */
export const postBulletinScopeChangeRequestReject = <ThrowOnError extends boolean = false>(options: Options<PostBulletinScopeChangeRequestRejectData, ThrowOnError>): RequestResult<PostBulletinScopeChangeRequestRejectResponses, PostBulletinScopeChangeRequestRejectErrors, ThrowOnError> => (options.client ?? client).post<PostBulletinScopeChangeRequestRejectResponses, PostBulletinScopeChangeRequestRejectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/bulletin_scope_change_request/{bulletin_scope_change_request_id}/reject',
    ...options
});

/**
 * Post Intel Request Submission
 *
 * Request an Intel submission from a user.
 *
 * If the user exists, sends them an email with a link to the OCIS area.
 * If the user doesn't exist, creates a new user with minimal permissions (login. and app.intel.),
 * sends a Stytch invite, and sends an email indicating they'll receive an invite.
 */
export const postIntelRequestSubmission = <ThrowOnError extends boolean = false>(options: Options<PostIntelRequestSubmissionData, ThrowOnError>): RequestResult<PostIntelRequestSubmissionResponses, PostIntelRequestSubmissionErrors, ThrowOnError> => (options.client ?? client).post<PostIntelRequestSubmissionResponses, PostIntelRequestSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/py/intel/request_submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
